import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductFilterModel } from '../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-filter-product',
    templateUrl: './filter-product.component.html',
    styleUrl: './filter-product.component.scss',
    standalone: false
})
export class FilterProductComponent {
  @Input() productFilter: ProductFilterModel;

  @Output() filterChanged = new EventEmitter<ProductFilterModel>(); 

  ngOnInit(): void {
    this.onTotalInitial()
  }

  onTotalInitial() {
    if (!this.productFilter.priceFrom) {
      this.productFilter.priceFrom = 0;
    }
    if (!this.productFilter.priceTo) {
      this.productFilter.priceTo = 2050;
    }
    this.filterChanged.emit(this.productFilter);
  }
}
